<template>
    <div class="form-group">
        <label v-if="label" v-bind="labelProps">{{ label }}</label>

        <v-date-picker
            @input="$emit('input', $event)"
            :value="value"
            :attributes="[
                {
                    key: 'today',
                    highlight: {
                        fillMode: 'light',
                        contentClass: 'bg-light'
                    },
                    dates: new Date(),
                },
            ]"
            :input-props="{
                class: 'form-control form-control-' + size,
                placeholder,
            }" :popover="{ visibility: 'click', }">
        </v-date-picker>
    </div>
</template>

<script>
    export default {
        props: {
            label: { default: null },
            placeholder: { default: 'Please select a date' },
            value: { default: null },
            size: { default: '' },
            labelProps: { default: null, type: Object }
        }
    };
</script>
